export { phpLaravel } from './laravel.js';
